import { render, staticRenderFns } from "./add-owner.vue?vue&type=template&id=21e97d08&"
import script from "./add-owner.vue?vue&type=script&lang=js&"
export * from "./add-owner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports